/** Normalize the POST /api/survey/templates/get/ response to the legacy field shape.
 *  Change 1: questions now carry reporting_category_ids instead of full reporting_categories objects.
 *  Change 2: languages are now a dict + two id-list fields instead of two full-object arrays. */
export default function normalizeTemplateGetResponse(template) {
  try {
    if (!template) return;

    // Change 2 — expand deduplicated language dict back to the two legacy arrays
    if (template.languages && template.supported_language_ids) {
      template.supported_languages = (template.supported_language_ids || [])
        .map(function(id) { return template.languages[id]; })
        .filter(Boolean);
      template.active_languages = (template.active_language_ids || [])
        .map(function(id) { return template.languages[id]; })
        .filter(Boolean);
    }

    // Change 1 — expand per-question reporting_category_ids to full objects
    if (Array.isArray(template.questions) && Array.isArray(template.reporting_categories)) {
      let rcMap = {};
      for (let i = 0; i < template.reporting_categories.length; i++) {
        rcMap[template.reporting_categories[i].id] = template.reporting_categories[i];
      }
      for (let j = 0; j < template.questions.length; j++) {
        let question = template.questions[j];
        if (Array.isArray(question.reporting_category_ids) && !question.reporting_categories) {
          question.reporting_categories = question.reporting_category_ids
            .map(function(id) { return rcMap[id]; })
            .filter(Boolean);
        }
      }
    }
  } catch (ex) {
    console.error("normalizeTemplateGetResponse : error : ", ex);
  }
}
